<template lang="html">
    <div class="content-wrapper" style="position:relative">
        <div class="row">
            <div class="col-sm-12 plan-header">
                <h2>{{lang=="ru"?"Проницательность дает возможность. Мы поможем вам торговать лучше с самого начала":"With insight comes opportunity. We'll help you trade better from the get-go"}}</h2>
            </div>
            <!-- <div style="text-align:center; width:100%; margin-top: 20px">
                <button class='btn btn-secondary' @click="change_type('m')" :style="plan_type=='m'?'background:green; border:none':''">Month</button>
                <button class='btn btn-secondary' @click="change_type('h')" :style="plan_type=='h'?'background:green; border:none':''">Half year</button>
            </div> -->
        </div>
        <div class="container-fluid">
            <div class="container main-third" id="plan">
            <div class="text-left">
                <div class="row sub">
                <div class="button-group">
                    <button @click="change_type('m')" :class="plan_type=='m'? 'button-active' : ''" id="month">{{lang=="ru"?"Месяц":"Month"}}</button>
                    <button @click="change_type('h')" :class="plan_type=='h'? 'button-active' : ''" id="half">{{lang=="ru"?"Полгода":"Half-year"}}</button>
                </div>
                <div class="row plan-group" id="month-card" style="width: 100%;">
                    <div class="col-md-3"></div>
                    <div :class="$parent.plan_status == 1 ? 'col-md-3 card-active' : 'col-md-3'">
                        <div class="card-header">
                            <p>Interim</p>
                        </div>
                        <div class="card-body">
                            <p class="card-first-letter">{{lang=="ru"?"Возможности для ознакомления:":"Opportunities to review:"}}</p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"2 доступных алгоритма":"2 available algorithms"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Отображение графиĸов":"Graph display"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Данные бэĸтеста для всех стратегий":"Backtest data for all strategies"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Подробная статистика":"Detailed statistics"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Ежемесячная личная история торгов":"Monthly personal trading history"}}</span></p>
                        </div>
                        <div class="card-bottom">
                            <p>Free</p>
                        </div>
                        <div class="card-button" @click="$parent.plan_status == 0 ? setLoaded(1, 0) : ''">
                            <p>{{$parent.plan_status == 1 ? 'Current' : 'Select'}}</p>
                        </div>
                    </div>
                    <div :class="$parent.plan_status == 4 ? 'col-md-3 card-active' : 'col-md-3'">
                        <div class="card-header">
                            <p>Advanced</p>
                        </div>
                        <div class="card-body">
                            <p class="card-first-letter">{{lang=="ru"?"Абсолютный пакет:":"Absolute package:"}}</p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Автоторговля для 3 любых алгоритмов на выбор":"Autotrading for any 3 algorithms of your choice"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Месяц":"Autotrading with percentage of balance"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Автоторговля процентом от баланса":"Take-profit"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Тейĸ-профит":"Stop-Loss"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Возможность закрывать текущие сделки через Telegram":"Closing the selected trade using the Telegram command"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Автоторговля фиĸсированной суммой":"Fixed amount for autotrading"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Уведомления по почте или Telegram":"Notifications by mail or Telegram"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Telegram-ĸоманда (для отображения теĸущего результата сделĸи)":"Telegram-command (to display the current trade result)"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Автоматичесĸое пополнение BNB (для уменьшения ĸомиссии за торговлю на Binance)":"Auto BNB deposit (to reduce trading fees on Binance)"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Возможность выбрать торговый аĸти":"Ability to choose a trading asset"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Возможность менять значения алгоритма":"Ability to change algorithm values"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Личная история торгов для ĸаждого алгоритма":"Personal trading history for each algorithm"}}</span></p>
                            <p class="card-letter"><span class="letter-symbol">○</span> <span>{{lang=="ru"?"Возможность подĸлючиться к сделке, если стратегия уже открыла позицию":"Ability to connect to the trade if the strategy has already opened position"}}</span></p>
                        </div>
                        <div class="card-bottom">
                            <p>{{plan_type=='m' ? 20 :100}} $/{{plan_type == 'm' ? 'month' : '6 months'}}</p>
                        </div>
                        <div class="card-button" @click="$parent.plan_status < 4 ? setLoaded(4, 35):''">
                            <p>{{$parent.plan_status==4?'Current':'Select'}}</p>
                        </div>
                    </div>
                    <div class="col-md-3"></div>
                </div>
                <p class="description-letter-1">
                Possible payment method: BTC, USDT, BCH, ETH, LTC.
                </p>
                </div>
            </div>
            </div>
        </div>
        <p class="bottom-letter"> {{lang=="ru"?"*Подписка не подлежит возврату":"*The subscription is not refundable"}}</p>
        <div>
            <simple-modal v-model="isShow" size="small">
                <template slot="body">
                    <div class="payment-log">
                       <img src="/static/images/icon.png" alt="logo"/>
                    </div>
                    <!-- <div class="payment-button">
                        <button id="yandex-button" class="pay-button" @click="setyandex()">Pay with yandex</button>
                    </div> -->
                    <div class="payment-button">
                        <button id="crypto-button" class="pay-button" @click="refillBalance('crypto')">Cryptocurrency</button>
                    </div>
                    <div v-if="lang=='ru'" class="payment-button">
                        <button id="thinkoff-button" class="pay-button" @click="settinkoff()">Card</button>
                    </div>
                    <div id="paypal-1" style="margin-top:20px"></div>
                </template>
            </simple-modal>
        </div>
        <div class="vld-parent">
          <loading :active.sync="isLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="fullPage"></loading>
        </div>
        <div>
            <simple-modal v-model="yandexModal">
                <template slot="body">
                    <div id="yandex" style="margin-top:20px">
                        <form method="POST" action="https://yoomoney.ru/quickpay/confirm.xml" id="yandex-form" ref="form">
                            <input type="hidden" name="receiver" value="4100116139400387">
                            <input id="yandex-sUrl" v-model='success_yan_url' name="successURL" value="" type="hidden">
                            <input type="hidden" name="formcomment" value="‘Nekita’ Project: Arc Reactor">
                            <input type="hidden" name="short-dest" value="‘Nekita’ Project: Arc Reactor">
                            <input type="hidden" name="label" value="">
                            <input type="hidden" name="quickpay-form" value="shop">
                            <input type="hidden" name="targets" value="Trading Ammo">
                            <input name="is-inner-form" value="true" type="hidden">
                            <input type="hidden" v-model='amount' name="sum" value="" data-type="number" id="amount">
                            <input type="hidden" name="comment" value="Please pay to this wallet with your card.">
                            <input type="submit" value="Transfer">
                        </form>
                    </div>
                </template>
            </simple-modal>
        </div>
    </div>
</template>

<script>
import SimpleModal from 'simple-modal-vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import LanguagesDropdown from 'vue-languages-dropdown'
export default {
    components: {
        SimpleModal,
        Loading,
        'languages-dropdown' : LanguagesDropdown
    },
    data() {
        return {
            lang:'en',
            isLoading: false,
            fullPage: true,
            isShow: false,
            loaded: false,
            yandexModal:false,
            refillAmount: 0,
            planStatus:0,
            latestRefills: [],
            success_yan_url:"",
            amount:"",
            currency:"",
            password: {
                old: '',
                new: '',
                new2: ''
            },
            binance: {
                pubkey: '',
                privkey: '',
                refillBnb: true
            },
            passwordUpdateError: null,
            selectedList : ['ru','en'],
            plan_type: null
        }
    },
    mounted() {
        const script = document.createElement("script");
        script.src = "https://www.paypal.com/sdk/js?client-id=AUZaMXwtHhFC1dxKZJjHZwYbSK62ISWHsMjLkTeJ34rS1MdpQvA20DfwYx6rTTEGkp5To0mfnwOyrAoF&disable-funding=credit,card";
        var attr=document.createAttribute('data-namespace');
        attr.value="paypal_sdk";
        script.setAttributeNode(attr);
        document.body.appendChild(script);
    },
    created() {
        this.lang = this.$cookie.get('lang');
        if(this.$parent.plan_type == 1){
            this.plan_type = 'm'
        }else{
            this.plan_type = 'h'
        }
    },
    methods: {
        setLoaded: function (plan, amount) {
            if(plan==1){
                this.axios.post('/user/plan_update',{
                    plan:1
                },{
                    withCredentials: true
                }).then(response => {
                    if (response.data.success) {
                        window.location.href="https://tradingapp.pro/app/#/dashboard/overview";
                    }
                })
                return false;
            }
            var user_status=this.$parent.plan_status
            var current_amount=0
            if(this.$parent.plan_type == 1){
                if ( user_status == 2 ){
                    current_amount = 15
                } else if( user_status == 3 ){
                    current_amount = 25
                } else if( user_status ==4 ){
                    current_amount = 20
                }
            } else{
                if ( user_status==2 ) {
                    current_amount = 75
                } else if ( user_status == 3 ) {
                    current_amount = 125
                } else if ( user_status==4 ) {
                    current_amount = 100
                }
            }
            let amounts = amount;
            if(this.plan_type == 'h') {
                if(plan == 2) {
                    amounts = 75
                }else if(plan == 3) {
                    amounts = 125
                }else if(plan == 4) {
                    amounts = 100
                }
            }

            this.refillAmount = amounts - current_amount
            if(this.refillAmount < 0) {
                return false;
            }
            this.planStatus = plan
            document.getElementById("paypal-1").innerHTML = "";
            this.currentprice = this.refillAmount
            this.isShow = !this.isShow
            this.loaded = true;
            var charge_id=null
            window.paypal_sdk.Buttons({
                createOrder: (data, actions) => {
                    this.axios.post('/user/refill',{
                        gateway:"paypal",
                        amount: this.refillAmount,
                        plan:this.planStatus,
                        plan_type: this.plan_type
                    },{
                        withCredentials: true
                    }).then(response => {
                        charge_id=response.data.charge_id;
                    })
                    return actions.order.create({
                        purchase_units: [{
                            description: "Payment wiht paypal.",
                            amount: {
                                currency_code: "USD",
                                value: this.currentprice
                            }
                        }]
                    });
                },
                onApprove: async (data, actions) => {
                    this.isLoading = true;
                    const order = await actions.order.capture();
                    console.log(order);
                    if(order.status=="COMPLETED"){
                    this.axios.post('/user/refill_update',{
                    charge_id: charge_id
                    },{
                        withCredentials: true
                    }).then(response => {
                        if (response.data.success) {
                            // this.isLoading = false
                           window.location.href="https://tradingapp.pro/app/#/dashboard/overview";
                        }
                    })
                    }else{
                    alert("Payment Error !");
                    }
                },
                onError: err => {
                    console.log(err);
                }
            }).render('#paypal-1');
        },
        refillBalance(gateway) {
            var refillTab = window.open('', '_blank')
            this.axios.post('/user/refill', {
                gateway,
                amount: this.refillAmount,
                plan:this.planStatus,
                plan_type: this.plan_type
            },
            {
                withCredentials: true
            }).then(response => {
                console.log(response.data)
                if (response.data.success) {
                    refillTab.location.href = response.data.payment_url
                }
            })
        },
        change_type (key) {
            this.plan_type = key
        },
        settinkoff (){
            this.isLoading = true;
            var yandex=this;
            this.axios.post('/user/refill', {
                gateway:"tinkoff",
                amount: this.refillAmount,
                plan:this.planStatus,
                plan_type: this.plan_type
            },
            {
                withCredentials: true
            }).then(response => {
                console.log(response.data)
                if(response.data.success){
                    window.location.href = response.data.payment_url
                }
            })
        },
        setyandex() {
            this.axios.get('/user/get_currency', {
              withCredentials: true
            })
            .then((response) => {
              this.currency=response.data.amount
            })
            var yandex=this;
            this.axios.post('/user/refill', {
                gateway:"yandex",
                amount: this.refillAmount,
                plan:this.planStatus,
                plan_type: this.plan_type
            },
            {
                withCredentials: true
            }).then(response => {
                console.log(response.data)
                if (response.data.success) {
                    this.currentprice = this.refillAmount;
                    this.loaded = true;
                    var charge_id=response.data.charge_id;
                    var success_yan_url="https://api.tradingapp.pro/callback?chatId="+charge_id;
                    var amount=yandex.refillAmount*this.currency
                    document.getElementById("amount").value =amount;
                    document.getElementById("yandex-sUrl").value =success_yan_url;
                    this.$refs.form.submit();
                }
            })
        }
    }
}
</script>

<style lang="css" scoped>
.main-third {
    padding: 20px  9.375%;
}
.card-bottom{
    height: 100px;
    border: 1px solid #2E2E2E;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card-bottom > p{
    text-align: center;
    color: white;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 49px;
    vertical-align: middle;
    margin: 0;
}

.card-button{
    height: 74px;
    background: #FFFFFF;
    border-right: 1px solid #2E2E2E;
    border-left: 1px solid #2E2E2E;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.feature {
    padding: 0 !important;
}

.card-button > p{
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #000000;
    margin: 0;
}

.card-body {
    border: 1px solid #2E2E2E;
    padding: 25px 40px;
}

.card-body > p {
    line-height: 20px;
    margin-bottom: 20px;
}

.card-first-letter {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 130%;
    /* or 18px */
    color: #FFFFFF;
}

.card-letter {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    color: #FFFFFF;
    display: flex;
    align-items: center;
}

.letter-symbol {
    font-size: 24px;
    padding-right: 10px;
}

.plan-group > .col-md-3:hover {
    background: linear-gradient(90deg, #171717 0%, #000000 100%);
}

.card-active {
    background: linear-gradient(90deg, #171717 0%, #000000 100%);
}
@media (min-width: 1200px) {
    .container {
        width: 100%;
        max-width: 100%;
    }
}
    .card-button > p{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: #000000;
        margin: 0;
    }

    .card-body {
        border: 1px solid #2E2E2E;
        padding: 25px 40px;
    }

    .card-body > p {
        line-height: 20px;
        margin-bottom: 20px;
    }

    .card-first-letter {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 130%;
        /* or 18px */
        color: #FFFFFF;
    }

    .card-letter {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 200;
        font-size: 12px;
        line-height: 130%;
        color: #FFFFFF;
        display: flex;
        align-items: center;
    }

    .letter-symbol {
        font-size: 24px;
        padding-right: 10px;
    }

    .plan-group > .col-md-3:hover {
        background: linear-gradient(90deg, #171717 0%, #000000 100%);
    }

    .card-active {
        background: linear-gradient(90deg, #171717 0%, #000000 100%);
    }

    #half-card {
        display: none;
    }

    .button-group {
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .button-group > button {
        width: 125px;
        height: 43px;
        background-color: black;
        border: 1px solid white;
        margin: 0;
        padding: 0;
        font-weight: 200;
        font-size: 18px;
        line-height: 130%;
        padding: 10px 20px;
    /* or 23px */
        color: #FFFFFF;
    }

    .button-group > button:hover {
        background-color: #323232 !important;
    }

    .button-active {
        background-color: #323232 !important;
    }
.row {
    margin-left: 0;
}

/* .sub {
    margin-top: 40px;
} */

.sub-title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 27px;
    text-transform: uppercase;
    color: #FFFFFF;
    border-bottom: 1px solid #FFFFFF;
    padding: 10px 0;
}

.sub-letter {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 100;
    font-size: 18px;
    line-height: 130%;
    color: #FFFFFF;
    margin-top: 20px;
}

.sub-letter-1 {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 100;
    font-size: 18px;
    line-height: 130%;
    color: #FFFFFF;
    margin-top: 50px;
    max-width: 586px;
}

.image-box > img {
    display: inline;
}

.sub > .col-md-4 {
    margin-top: 20px;
}

.description-letter-1 {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 200;
    font-size: 12px;
    line-height: 130%;
    color: #FFFFFF;
    margin-top: 10px;
}

.button-group {
    text-align: center;
    display: flex;
    justify-content: center;
    width: 100%
}

.button-group > button {
    width: 125px;
    height: 43px;
    background-color: black;
    border: 1px solid white;
    margin: 0;
    padding: 0;
    font-weight: 200;
    font-size: 18px;
    line-height: 130%;
    padding: 10px 20px;
/* or 23px */
    color: #FFFFFF;
}

.button-group > button:hover {
    background-color: #323232 !important;
}

.button-active {
    background-color: #323232 !important;
}

.plan-group {
    margin-top: 30px;
    border: 1px solid white;
}

.plan-group > div {
    padding: 0;
    cursor: pointer;;
}

.card-header{
    height: 100px;
    border: 1px solid #2E2E2E;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card-header > p{
    text-align: center;
    color: white;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 27px;
    text-transform: uppercase;
    vertical-align: middle;
    margin: 0;
}
    .payment-button{
        margin-top: 10px;
    }
    .form-check-primary{
        display: none !important;
    }
    .vsm-modal{
        max-width: 500px !important;
    }
    @media (min-width: 992px){
        .vsm-modal{
            max-width: 500px !important;
        }
    }

    .payment-button{
        margin-top: 20px;
    }
    .pay-button{
        width:100%;
        margin-right: 5px;
        color: #fff;
        background-color: #464dee;
        border-color: #464dee;
        padding: 12px;
        border: none;
        font-size: 14px;

    }
    button.pay-button:hover {
    -webkit-box-shadow: 0 2px 2px 0 rgb(70 77 238 / 14%), 0 3px 1px -2px rgb(70 77 238 / 20%), 0 1px 5px 0 rgb(70 77 238 / 12%);
    box-shadow: 0 2px 2px 0 rgb(70 77 238 / 14%), 0 3px 1px -2px rgb(70 77 238 / 20%), 0 1px 5px 0 rgb(70 77 238 / 12%);
    }
    .plan__perk>span>img{
        width: 16px;
    }
    .point-marker{
        width: 20px !important;
    }
    .button, .button.disabled:hover {
        display: block;
        margin-bottom: 20px;
        text-decoration: none;
        border:1px solid #25729a;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        font-family:arial, helvetica, sans-serif;
        text-shadow: -1px -1px 0 rgba(0,0,0,0.3);
        text-align: center;
        color: #FFFFFF;
        background-color: #3093c7;
        background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #3093c7), color-stop(100%, #1c5a85));
        background-image: -webkit-linear-gradient(top, #3093c7, #1c5a85);
        background-image: -moz-linear-gradient(top, #3093c7, #1c5a85);
        background-image: -ms-linear-gradient(top, #3093c7, #1c5a85);
        background-image: -o-linear-gradient(top, #3093c7, #1c5a85);
        background-image: linear-gradient(top, #3093c7, #1c5a85);filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=#3093c7, endColorstr=#1c5a85);
    }

    .button:hover{
        border:1px solid #1c5675;
        background-color: #26759e;
        background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#26759e), color-stop(100%, #133d5b));
        background-image: -webkit-linear-gradient(top, #26759e, #133d5b);
        background-image: -moz-linear-gradient(top, #26759e, #133d5b);
        background-image: -ms-linear-gradient(top, #26759e, #133d5b);
        background-image: -o-linear-gradient(top, #26759e, #133d5b);
        background-image: linear-gradient(top, #26759e, #133d5b);filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=#26759e, endColorstr=#133d5b);
    }
    .button.disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
    .payment-log{
        margin-top: 10px;
        text-align: center;
    }
    .payment-log>img{
        width: 60px;
    }
    .bottom-letter{
        bottom:20px;
        position: absolute;
        right: 10px
    }
    @media (max-width: 767px) {

    .row {
        padding: 0 !important;
    }

    .menu {
        background-color: black;
    }
    .nav-tabs > li > a {
        border: none;
    }
    .main-title {
        font-weight: 400;
        font-size: 30px;
        line-height: 110%;
    }
    .feature {
        padding: 0;
        margin-top: 150px;
    }
    .main-second {
        padding-left: 10px;
    }
    .main-title-description {
        font-weight: 200;
        font-size: 15px;
        line-height: 130%;
        margin-top: 20px;
        
    }
    .header-image {
        display: inline;
        margin-top: 20px;
        width: 110%;
    }
    .main-third {
        padding: 0;
        margin-top: 120px;
    }
    /* .image-box {
        display: none;
    } */
    .col-md-7 {
        display: none;
    }

    .main-title-1 {
        font-weight: 400;
        font-size: 30px;
        line-height: 37px;
    }
    .sub-title {
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
    }
    .row {
       margin: 0
    }
    .plan-group {
        margin-top: 20px;
    }

    .card-button {
        border: none;
    }
    .bs-example {
        margin: 0;
    }
    .footer-part {
        padding: 20px;
        margin-top: 150px;
        border-top: 1px solid #FFFFFF;
    }

    .footer-part > div > div > .col-md-4 {
        margin-top: 50px;
    } 
    .sub-letter-1 {
        font-weight: 200;
        font-size: 13px;
        line-height: 130%;
    }
    .sub-2 {
        padding: 0;
        margin-top: 0;
    }
    .form-button > button {
        width: 100%;
        border: none;
        font-size: 12px;
    }

    .panel-title > a {
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
    }

    .panel-body > p {
        font-weight: 200;
        font-size: 13px;
        line-height: 130%;
    }

    .form-label {
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
    }
    .containers {
        font-weight: 200;
        font-size: 14px;
        line-height: 130%;
    }
    .checkmark {
        height: 20px;
        width: 20px;
    }
    .containers .checkmark:after {
        left: 0;
        top: 0;
        /* width: 5px;
        height: 9px; */
    }

    .sub-title-number {
        text-align: center;
        max-width: 187px;
    }

    .sub-letter-number {
        font-weight: 200;
        font-size: 13px;
        line-height: 130%;
        height: 30px;
        margin-top: 30px;
        max-width: 187px;
    }

    .sub-1 > .col-md-4 {
        margin-top: 50px;
    }

    .description-letter {
        display: none;
    }
    .sub-letter {
        font-size: 13px;
    }
    .navbar-brand {
        padding-top: 15px;
        padding-bottom: 0;
    }
    .sub-1 {
        padding-left: 46px !important;
    } 
}
</style>



// WEBPACK FOOTER //
// src/components/Plans.vue